// SWR background revalidation cadence for live dashboard data.
export const SWR_REFRESH_MS = 30_000;

// Release notes change once per deploy, so What's New polls far less often; focus revalidation still catches up.
export const RELEASES_REFRESH_MS = 15 * 60_000;

// Locale for every date shown in the dashboard, e.g. "5 Jan 2026".
export const DATE_LOCALE = "en-GH";

// Public booking app origin; an owner's link is `${BOOKING_URL}/${slug}`.
export const BOOKING_URL = process.env.NEXT_PUBLIC_BOOK_URL ?? "https://book.gethapo.com";

// Calendar dot density: <= low -> 1 dot, <= medium -> 2 dots, else 3.
export const CALENDAR_DENSITY = { low: 2, medium: 5 } as const;

// Canonical Ghana mobile number format: +233 followed by exactly 9 digits.
// Single source of truth for phone validation across forms and Zod schemas.
export const GHANA_PHONE_RE = /^\+233[0-9]{9}$/;
export const GHANA_PHONE_MESSAGE = "Must be a valid Ghana number: +233XXXXXXXXX";

// Cloudflare Turnstile sitekey (public, safe to embed client-side — the
// secret lives server-side as TURNSTILE_SECRET). Shared by the signup and
// login widgets.
export const TURNSTILE_SITE_KEY = "0x4AAAAAAEDH6eZpvO41oExD";

// Per-service image cap shown in the owner UI. Mirrors the compiled-in default
// of pricing.serviceImages.maxPerService (api/internal/platform-policy/policy.go)
// — that value is not currently exposed via GET /v1/platform-policy, so this is
// kept in sync manually. The Go API is the actual source of truth and rejects
// uploads past the cap regardless of this constant.
export const MAX_SERVICE_IMAGES = 5;

// Polling cadence for service image moderation status (pending/error -> clean/
// flagged). The moderation worker runs on a 30s ticker, so this trades a few
// extra polls for feeling responsive rather than waiting a full cycle.
export const SERVICE_IMAGE_POLL_MS = 4_000;
// Give up polling after this many attempts (~80s) rather than forever, in case
// a photo genuinely gets stuck — the owner can still reload the page.
export const SERVICE_IMAGE_POLL_MAX_ATTEMPTS = 20;

// Mobile-money providers. Keys are the API enum (momo_provider in Postgres),
// values are what an owner is shown — "vodafone" has been Telecel since the
// rebrand, so the raw enum value must never reach the screen.
export const MOMO_PROVIDER_LABELS = {
  mtn:        "MTN",
  vodafone:   "Telecel",
  airteltigo: "AirtelTigo",
} as const;

// Booking statuses surfaced in dashboard filters. value = API enum, label = display.
export const BOOKING_STATUS_OPTIONS = [
  { value: "pending",   label: "Pending" },
  { value: "confirmed", label: "Confirmed" },
  { value: "attended",  label: "Attended" },
  { value: "no_show",   label: "No-show" },
  { value: "cancelled", label: "Cancelled" },
  { value: "expired",   label: "Expired" },
] as const;

// Where an email-verification link lands; Better Auth reads it per request, not from auth config.
export const VERIFY_CALLBACK_URL = "/verifying";

export const SUPPORT_EMAIL = "hello@gethapo.com";
